module.exports = __webpack_public_path__ + "media/svg-new/thumb-down-000f4627.svg";